import { Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { AgreementsClient } from '@unity/clients';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridAgreementFormSharedComponent } from '@unity/shared/grid-agreement-form-shared/grid-agreement-form-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-agreement-form-schedules-page',
  imports: [GridAgreementFormSharedComponent, PageContainerComponent, ActionSharedComponent],
  templateUrl: './list-agreement-form-schedules-page.component.html',
  styleUrl: './list-agreement-form-schedules-page.component.scss',
})
export class ListAgreementFormSchedulesPageComponent {
  private readonly agreementsClient = inject(AgreementsClient);

  protected agreementResource = rxResource({
    params: () => {
      const agreementId = this.$agreementId();
      return agreementId ? { agreementId } : undefined;
    },
    stream: ({ params: { agreementId } }) => this.agreementsClient.getOneAsMini(agreementId),
  });

  protected readonly $createFormScheduleAction = computed(() => {
    const agreementId = this.$agreementId();
    return QuickActions.CreateFormSchedule(agreementId);
  });

  protected readonly $isAgreementLoading = this.agreementResource.isLoading;
  protected readonly $agreementName = computed(() => (this.agreementResource.hasValue() ? this.agreementResource.value().name : undefined));

  protected readonly $contentHeaderSecondary = computed(() => {
    const agreement = this.$agreementName();
    return `Agreement: ${agreement}`;
  });

  public readonly $agreementId = input.required({ alias: 'agreementId', transform: (value: string) => parseInt(value) });
  protected readonly $returnToAgreementAction = computed(() => QuickActions.ReturnToAgreement(this.$agreementId()));
}
